module.exports = __webpack_public_path__ + "../../img/back.172fc3c2.png";